import { render, staticRenderFns } from "./LiveProduct.vue?vue&type=template&id=834c5c46&"
import script from "./LiveProduct.vue?vue&type=script&lang=js&"
export * from "./LiveProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports